import actions from './actions'

const initialState = {
  id: '',
  name: '',
  role: '',
  email: '',
  avatar: '',
  authorized: process.env.REACT_APP_AUTHENTICATED || false, // false is default value
  loading: false,
  umkProcessing: false,
  // serverType: '',
  safebox: null,
  workspace: null,
  provisioning: false
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    // case actions.SET_STATE0:
    //   if (state === initialState) {
    //     return { ...state, ...action.payload }
    //   }
    //   if (action.payload != null) {
    //     Object.entries(action.payload).forEach(([key, value]) => {
    //       state[key] = value;
    //     })
    //   }
    //   return state
    default:
      return state
  }
}
